<!--
 * @Author: Vben
 * @Description: logo component
-->
<template>
  <div class="anticon" :class="getAppLogoClass" @click="goHome">
    <div
      class="ml-2 truncate md:opacity-100 font-regular"
      :class="getTitleClass"
      :style="{ fontSize: titleFontSize }"
      v-show="showTitle && !isShowLogo"
    >
      {{ appTitle }}
    </div>
    <img v-if="isShowLogo" :src="LogoYl" alt="" style="width: 178px; height: auto" />
  </div>
</template>
<script lang="ts" setup>
  import { computed, unref, ref } from 'vue';
  import { useGlobSetting } from '/@/hooks/setting';
  import { useGo } from '/@/hooks/web/usePage';
  import { useMenuSetting } from '/@/hooks/setting/useMenuSetting';
  import { useDesign } from '/@/hooks/web/useDesign';
  import { useI18n } from '/@/hooks/web/useI18n';
  import { PageEnum } from '/@/enums/pageEnum';
  import { useUserStore } from '/@/store/modules/user';
  // import { useAppStore } from '/@/store/modules/app';
  // const appStore = useAppStore();
  import LogoYl from '/@/assets/images/logo-yl.jpg';
  import { useOrganizationId } from '/@/hooks/nurse/useOrganizationId';
  const { isSpecialOrganizationId } = useOrganizationId([42]);
  const isShowLogo = ref(isSpecialOrganizationId);
  const props = defineProps({
    /**
     * The theme of the current parent component
     */
    theme: { type: String, validator: (v: string) => ['light', 'dark'].includes(v) },
    /**
     * Whether to show title
     */
    showTitle: { type: Boolean, default: true },
    /**
     * The title is also displayed when the menu is collapsed
     */
    alwaysShowTitle: { type: Boolean },
  });

  const { prefixCls } = useDesign('app-logo');
  const { getCollapsedShowTitle } = useMenuSetting();
  const userStore = useUserStore();
  const { title } = useGlobSetting();
  const { t } = useI18n();
  const appTitle = computed(() => t('layout.appTitle') || title);
  // 根据标题长度动态调整字号：中文等短标题保持 28px，英文等长标题自动缩小避免溢出
  const titleFontSize = computed(() => {
    const len = appTitle.value.length;
    if (len > 12) return '16px';
    if (len > 6) return '20px';
    return '28px';
  });
  const go = useGo();

  const getAppLogoClass = computed(() => [
    prefixCls,
    props.theme,
    { 'collapsed-show-title': unref(getCollapsedShowTitle) },
  ]);

  const getTitleClass = computed(() => [
    `${prefixCls}__title`,
    {
      'xs:opacity-0': !props.alwaysShowTitle,
    },
  ]);

  function goHome() {
    // appStore.setProjectConfig({
    //   menuSetting: {
    //     show: true,
    //   },
    // });
    go(userStore.getUserInfo.homePath || PageEnum.BASE_HOME);
  }
</script>
<style lang="less" scoped>
  @prefix-cls: ~'@{namespace}-app-logo';

  .@{prefix-cls} {
    display: flex;
    align-items: center;
    padding-left: 7px;
    cursor: pointer;
    transition: all 0.2s ease;

    &.light {
      //border-bottom: 1px solid @border-color-base;
    }

    &.collapsed-show-title {
      padding-left: 20px;
    }

    &.light &__title {
      color: @primary-color;
    }

    &.dark &__title {
      color: @white;
    }

    &__title {
      transition: all 0.5s;
      line-height: normal;
      font-weight: 400;
      font-size: 28px;
      color: #323232 !important;
    }
  }
</style>
